export function changePageTitle(prefix: string): void {
  const suffix = 'Educacional'
  document.title = `${prefix} | ${suffix}`
}
